var map = {
	"./btn-add-bg.jpg": 1425,
	"./howWork-1.jpg": 75968,
	"./index-head-bg-h5.jpg": 66392,
	"./index-head-bg.jpg": 80377,
	"./referral-total-bg1.jpg": 54357,
	"./referral-total-bg2.jpg": 41258,
	"./reward/mining-q-1.jpg": 10472
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19570;